import Client from '../HttpClient';

const baseUrl = '/gateway/numbat-api/api/vs/manager';

const list = (merchantId, payload) => {
	return Client.get(`${baseUrl}/${merchantId}/franchiseeBranchs`, payload);
};

const find = (merchantId, id) => {
	return Client.get(`${baseUrl}/${merchantId}/franchiseeBranchs/${id}`);
};

const create = (merchantId, payload) => {
	return Client.post(`${baseUrl}/${merchantId}/franchiseeBranchs`, payload);
};

const update = (merchantId, id, payload) => {
	return Client.put(
		`${baseUrl}/${merchantId}/franchiseeBranchs/${id}`,
		payload
	);
};

const remove = (merchantId, id) => {
	return Client.del(`${baseUrl}/${merchantId}/franchiseeBranchs/${id}`);
};

export default {
	list,
	find,
	create,
	update,
	remove,
};
